export default {
  isLiveMode: (state) => {
    return state.mode === "live";
  },
  getCountryName: (state) => (countryCode) => {
    let cc = state.countryCodes.filter(
      country => country.id === countryCode
    );
    return cc.length > 0 ? cc[0].name_localized : null;
  },
  getCameraId: (state) => {
    return state.camerasSelected.id;
  },
  getCountryAlpha2: (state) => (countryCode) => {
    let cc = state.countryCodes.filter(
      country => country.id === countryCode
    );
    return cc.length > 0 ? cc[0].alpha2.toLowerCase() : null;
  },
  getVesselLivePosition: (state) => {
    return state.vesselLivePosition;
  },
};
